import {
  zlbApiOfficeWorkSummaryDetailPost,
  zlbApiOfficeWorkSummaryListPost,
} from 'src/api/zlbWorkSummary';
import { getOfficeWorkSummaryList } from '../services/index';

export default {
  namespace: 'workSummaryStore',
  state: {
    userTypeList: [],
    detail: {},
  },
  effects: {
    *getWorkSummaryList({ payload }, { call }) {
      const result = yield call(zlbApiOfficeWorkSummaryListPost, payload);
      return result;
    },
    *getWorkSummaryInfo({ payload }, { call, put }) {
      const result = yield call(zlbApiOfficeWorkSummaryDetailPost, payload);
      yield put({
        type: 'update',
        payload: {
          detail: result || {},
        },
      });

      return result;
    },
    //工作总结
    *getOfficeWorkSummaryList({ payload }, { call }) {
      const result = yield call(getOfficeWorkSummaryList, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
